<template>
	<div>
		<import
			:onImported="onImported"
			import-url="/api/users/import"
			button-text="Download Import Template"
			template-url="/admin/users/import-template"
			export-button-text="Download Current Users"
			export-url="/admin/users/export"
		>
			<template v-slot:before-import>
				<div>
					<p><b>Instructions</b></p>
					<p>
						You can download all current users, modify any user in
						there and re-import the file.
					</p>
					<p>
						To create new users, please use the Import Template
						below.
					</p>
					<p>
						<b>Permission Group</b> column can be one of: <b>L2</b>,
						<b>L4</b> or <b>L5</b>
					</p>
					<p>
						<b>Reset Password?</b> column can be used to send out a
						reset password email to the user. You can set it
						<b>Y</b> for Yes, and <b>N</b> for No.
					</p>
					<br />
					<p><b>Required Fields</b></p>
					<p>Email, Display Name</p>
				</div>
			</template>
		</import>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Import from "@components/partials/Import";

export default {
	components: {
		Import
	},
	computed: {
		...mapGetters("admin", {
			USERS: "users",
			LAST_PAGE: "usersLastPage",
			PAGE: "usersPage"
		})
	},
	methods: {
		...mapActions({
			GET_USERS: "getUsers"
		}),

		getUsers() {
			this.GET_USERS({ admin: true, page: 1, replace: true }).then(() =>
				this.GET_USERS({ admin: true, page: 2 })
			);
		},

		onImported() {
			// console.log("refreshing users");

			this.getUsers();
		}
	}
};
</script>
